import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getNewPrescriptionList,
  refillPrescription,
} from "../../actions/prescriptionAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import { getUserDetail, formatDate } from "../../utils/helper";
import FeedbackPopup from "./FeedbackPopup";
import UnorderedPrescriptionDetailPopup from "./UnorderedPrescriptionDetailPopup";

const NewPrescriptionList = () => {
  const newPrescriptions = useSelector(
    (state) => state.prescription.newPrescriptions
  );
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [activePrescriptionId, setActivePrescriptionId] = useState(0);
  const [showPrescription, setShowPrescription] = useState(false);
  const [dateForDetail, setDateForDetail] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getNewPrescriptionList());
  }, []);

  const removeItem = (actionName, id) => {
    var params = {
      params: {
        action: "rejectRx",
        prescription_id: activePrescriptionId,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      refillPrescription(params, () => {
        dispatch(getNewPrescriptionList());
      })
    );
  };

  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className="btn-orange btn-table "
            onClick={() => {
              setDateForDetail(formatDate(row.Created_Date));
              setActivePrescriptionId(row.ID);
              setShowPrescription(true);
            }}
          >
            View / Order
          </button>

          <button
            className=" btn-orange btn-black  btn-table "
            onClick={() => {
              setActivePrescriptionId(row.ID);
              setShowConfirmDialog(true);
            }}
          >
            Deny
          </button>
        </div>
      </>
    );
  };

  const columns = [
    {
      dataField: "Created_Date",
      text: "Date Created",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.Created_Date);
      },
    },
    {
      dataField: "Practitioner_Name",
      text: "Practitioner",
      sort: true,
    },
    {
      dataField: "Status",
      text: "Status",
      sort: true,
    },
    {
      dataField: "feedback",
      text: "Feedback",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => {
              setActiveItem({
                prescriptionId: row.ID,
                feedback: row.PRSC_Patient_Feedback,
                date: row.PRSC_Patient_Feedback_Date,
              });
              setShowFeedbackPopup(true);
            }}
          />
        );
      },
    },

    {
      dataField: "action",
      text: "Action",
      formatter: patientAction,
    },
  ];

  return (
    <div>
      <h5 className="profile-title mb-1">New / Unordered Prescriptions</h5>
      {showFeedbackPopup && (
        <FeedbackPopup
          closePopup={() => setShowFeedbackPopup(false)}
          previousFeedback={activeItem}
        />
      )}
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure want to remove this prescription?"
          acceptAction={removeItem}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      {showPrescription && (
        <UnorderedPrescriptionDetailPopup
          closePopup={() => setShowPrescription(false)}
          prescriptionId={activePrescriptionId}
          date={dateForDetail}
        />
      )}
      {newPrescriptions.length > 0 ? (
        <BootstrapTable
          classes="react-bootstrap-table"
          keyField="ID"
          columns={columns}
          data={newPrescriptions}
          headerClasses="header-class"
        />
      ) : (
        <p className="page-desc">
          There are no New / Unordered prescription at this time
        </p>
      )}
    </div>
  );
};

export default NewPrescriptionList;
